module.exports = __webpack_public_path__ + "img/spot.54f1511e.png";